import script from "./SpotWorkerSummaryApp.vue?vue&type=script&setup=true&lang=ts"
export * from "./SpotWorkerSummaryApp.vue?vue&type=script&setup=true&lang=ts"

import "./SpotWorkerSummaryApp.vue?vue&type=style&index=0&id=5ff06c1d&lang=css"

const __exports__ = script;

export default __exports__